"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneDynamicLoginRequest = void 0;
var PhoneDynamicLoginRequest = /** @class */ (function () {
    function PhoneDynamicLoginRequest() {
    }
    return PhoneDynamicLoginRequest;
}());
exports.PhoneDynamicLoginRequest = PhoneDynamicLoginRequest;
;
//# sourceMappingURL=phoneDynamicLogin.request.js.map